// TODO:....add some comments
( function ( $ ) {
	$( document ).ready( function () {
		var $companionForm = $( '[data-companion-form]' );
		var $scrollTarget = $( $companionForm.data( 'scrollTarget' ) );
		var $navbar = $( 'nav.navbar' );

		if ( $companionForm && $companionForm.length ) {
			var $inputs = $companionForm.find( '[data-input]' );
			var $linkedForms = $( $companionForm.data( 'companionForm' ) );

			if ( $companionForm.data( 'keepInputsSynced' ) ) {
				$inputs.each( function() {
					var $input = $( this );
					$linkedForms.each( function( ) {
						var $linkedForm = $( this );
						var $linkedInput = $linkedForm.find( $input.data( 'input' ) );

						$input.on( 'input', function() {
							$linkedInput.val( $input.val() );
						} );

						$linkedInput.each( function( curIndex ) {
							var $curLinkedInput = $( this );
							$curLinkedInput.on( 'input', function() {
								$linkedInput.filter( function( i ) { return i != curIndex; } ).val( $curLinkedInput.val() );
								$input.val( $curLinkedInput.val() );
							} );
						} );
					} );
				} );
			}

			$companionForm.on( 'submit', function( e ) {
				e.preventDefault();
				
				$inputs.each( function( ) {
					var $input = $( this );

					$linkedForms.each( function( ) {
						var $linkedForm = $( this );
						var $linkedInput = $linkedForm.find( $input.data( 'input' ) );

						$linkedInput.val( $input.val() );
					} );
				} );

				$linkedForms.trigger( 'submit' );

				if ( $linkedForms.length > 0 || $scrollTarget.length > 0 ) {
					var newScrollTop = $scrollTarget.length ? $scrollTarget.offset().top : $linkedForms.offset().top;
					var scrollTopOffset = $navbar.length ? -$navbar.first().outerHeight() : 0;
					$( 'html, body' ).animate( { scrollTop: newScrollTop + scrollTopOffset }, 300 );
				}
			} );
		}
	} );
} )( jQuery );
